import React, { Component } from "react"
import { Link } from "gatsby"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import AOS from "aos"
import 'aos/dist/aos.css';
import NewsStrip from "../../components/news-strip";
import imgDigitalMaintenance from "../../images/news/digital-periodic-maintenance.jpg"
import mainImg from "../../images/pcv-drivers.jpg";
import driverImg from "../../images/bus-coach-driver-jobs.jpg";
import arrowSvg from "../../images/arrow-circle-right-solid.svg"

class JobsPage extends Component {

  componentDidMount() {
    AOS.init();
    window.addEventListener('load', AOS.refresh);
    // @NOTE: Hack to force AOS to work :(
    window.setTimeout(AOS.refresh, 1000);
  }

  componentDidUpdate() {
    AOS.refresh();
  }

  render() {
    return (
      <Layout>
        <SEO title="Mechanic Leeds Jobs" description="Mechanic? Find your next career at Tetley's Coaches - Leeds' oldest coach operator established 1949." />
        <div className="block-services inner-body-bg">
          <div className="body gutter page-content-parent page-article headblock">
            <h1 className="headblock__heading">Mechanic Leeds</h1>
            <p className="headblock__byline">Find a career with Tetley's Coaches</p>
          </div>
          <div className="body gutter page-article page-content-parent">
            <h2 data-aos='fade-left' data-aos-duration="500" style={{ marginBottom: 20 }}>Mechanic – Coach & Bus Fleet Maintenance</h2>
            <div className="page-content">
              <div className="page-content__text" style={{ width: '100%' }}>
                <img src={imgDigitalMaintenance} alt="" />
                <p>Tetley’s Motor Services is recruiting for a full-time Mechanic to join our established team. This position offers a 40-hour week, with opportunity for occasional overtime.</p>
                <p><strong>Location:</strong> Leeds (LS10)</p>
                <p><strong>Salary:</strong> £20.26 per hour</p>
                <p><strong>Hours:</strong> Full-time, 40 hours per week (Monday to Friday between 07:00 - 18:00, with occasional overtime)</p>
                <p><strong>Contract:</strong> Permanent</p>
                <h3>Why Join Us?</h3>
                <br></br>
                <p>We are Tetley’s Motor Services Ltd — a well-established operator in Yorkshire with a modern, high-spec fleet of both coaches and buses. You’ll work in a fully equipped workshop, supporting the safe, reliable operation of our vehicles and playing a key role in maintaining our high standards.</p>
                <h3>What the Role Involves</h3>
                <br></br>
                <ul>
                  <li>Carrying out safety inspections, servicing and repairs on our coach and bus fleet.</li>
                  <li>Diagnosing mechanical, electrical, hydraulic and pneumatic faults on large vehicles.</li>
                  <li>Preparing vehicles for MOTs (where applicable) and ensuring full compliance with DVSA & Traffic Commissioner standards.</li>
                  <li>Completing job cards, defect sheets and maintenance records accurately and on time.</li>
                  <li>Supporting breakdown recovery for coaches/buses when required.</li>
                  <li>Maintaining workshop tools, equipment and ensuring a clean, safe work environment.</li>
                </ul>

                <h3>What We’re Looking For</h3>
                <br></br>
                <h4>Essential</h4>
                <ul>
                  <li>Proven experience working on coach, bus, PCV or HGV vehicles.</li>
                  <li>Strong mechanical and diagnostic skills relevant to large-vehicle fleets.</li>
                  <li>Full UK driving licence.</li>
                  <li>Excellent attention to detail and commitment to safety & quality.</li>
                  <li>Ability to work independently and as part of a workshop team.</li>
                </ul>
                <h4>Preferred</h4>
                <ul>
                  <li>NVQ Level 3 (or equivalent) in Heavy Vehicle Maintenance & Repair.</li>
                  <li>PCV licence. </li>
                  <li>Previous experience in coach or bus fleet maintenance.</li>
                </ul>

                <h3>What we offer</h3>
                <br></br>
                <ul>
                  <li>Competitive salary: <strong>£20.26 per hour</strong></li>
                  <li>40-hour working week (Mon–Fri) with overtime opportunities.</li>
                  <li>5.6 weeks’ paid annual leave (including statutory holidays).</li>
                  <li>Company pension scheme.</li>
                  <li>Ongoing training, development and long-term employment stability.</li>
                  <li>Strong culture of safety and team support within a respected operator.</li>
                </ul>


                <div id="jobs-apply" style={{ width: '100%', maxWidth: '100%' }} className="page-content__text">
                  <div className="content-box" style={{ width: '100%', maxWidth: '100%' }}>
                    <h3>Apply now</h3>
                    <p>Send your CV and a short covering by email to <a href="mailto:admin@tetleyscoaches.co.uk?subject=Mechanic – Coach %26 Bus Leeds">admin@tetleyscoaches.co.uk</a>, quoting "<strong>Mechanic – Coach & Bus Leeds</strong>" in the subject line.</p>
                    <p>Immediate start available.</p>
                    <p></p>
                  </div>
                </div>

                <p style={{ margin: 0 }}>
                  <Link to="/applicant-privacy-policy/" className="privacy-notice-link">
                    Applicant Privacy Notice
                  </Link>
                </p>

              </div>

            </div>
          </div>
        </div>

        <NewsStrip />

      </Layout>
    );
  }
}

export default JobsPage
